import './Markdown.css';
export var MarkdownWrapperCSS = '_14dgpdh0-3-8-0';